<template>
	<div class="filters-box">
		<div class="filters-box-row" :style="collapse ? 'height: 42px' : ''">
			<div class="data-picker-box">
				<span>下单时间：</span>
				<el-date-picker
					v-model="dateValue"
					size="small"
					:clearable="false"
					type="datetimerange"
					align="right"
					style="width:420px"
					popper-class="filter-time-popper"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:default-time="['00:00:00', '23:59:59']"
					format='yyyy-MM-dd HH:mm'
					value-format='yyyy-MM-dd HH:mm'>
				</el-date-picker>
			</div>
			<div class="order-NO-box">
				<span>主单据编号：</span>
				<el-input v-model="ordernumber" placeholder="请输入主单据编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>客户名称：</span>
				<el-input v-model="customerName" placeholder="请输入客户名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-type-box">
				<span>客户类别：</span>
				<el-select v-model="customercategoryid" filterable collapse-tags multiple class="order-type-select" size='small'>
					<!-- <el-option value="0" label="全部"></el-option> -->
					<el-option v-for="item in customList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
				</el-select>
			</div>
			<div class="order-type-box">
				<span>主订单状态：</span>
				<el-select v-model="orderstatus" collapse-tags multiple placeholder="请选择订单状态" class="order-type-select" size="small">
					<!-- <el-option value="全部" label="全部"></el-option> -->
					<el-option value="待付款" label="待付款"></el-option>
					<el-option value="待接单" label="待接单"></el-option>
					<el-option value="财务审核" label="财务审核"></el-option>
					<el-option value="待发货" label="待发货"></el-option>
					<el-option value="备货中" label="备货中"></el-option>
					<el-option value="待收货" label="待收货"></el-option>
					<el-option value="已完成" label="已完成"></el-option>
				</el-select>
			</div>
			<div class="order-type-box">
				<span>子单据类型：</span>
				<el-select v-model="childordertype" placeholder="请选择单据类型" class="order-type-select" size="small">
					<el-option
						v-for="item in options"
						:key="item.id"
						:label="item.value"
						:value="item.id">
					</el-option>
				</el-select>
			</div>
			<div class="order-name-box">
				<span>第三方编号：</span>
				<el-input v-model="matchCode" placeholder="请输入第三方编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>第三方支付流水号：</span>
				<el-input v-model="paymentnumber" placeholder="请输入第三方编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-type-box">
				<span>店铺名称：</span>
				<el-select v-model="shopids" class="order-type-select" collapse-tags multiple size='small'>
					<el-option v-for="item in shopList" :value="item.id" :label="item.name" :key="item.id"></el-option>
				</el-select>
			</div>
			<div class="order-type-box">
				<span>是否赠品：</span>
				<el-select v-model="giftFlag" class="order-type-select" size="small">
					<el-option value="全部" label="全部"></el-option>
					<el-option value="是" label="是"></el-option>
					<el-option value="否" label="否"></el-option>
				</el-select>
			</div>
		</div>
		<div class="collapse-box">
			<el-button size="small" type="text" class="btn" style="color:var(--fx-primary-color);margin-left:10px" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:var(--fx-primary-color);"/>
			</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	data () {
		return {
			shopids: [],
			shopList: [],
			options: [
				{ value: '全部', id: '' },
				{ value: '子订单', id: '0' },
				{ value: '子退单', id: '1' }
			],
			childordertype: '',
			ordernumber: '',
			pname: '',
			dateValue: [],
			customerName: '',
			pcode: '',
			matchCode: '',
			paymentnumber: '',
			bigcategoryview: null,
			bigcategoryid: '0',
			smallcategoryid: '0',
			liquidateflag: '全部',
			giftFlag: '全部',
			bc: [],
			sc: [],
			orderstatus: [],
			customercategoryid: [],
			customList: [],
			collapse: true
		}
	},
	created () {
		this.checkSmallCategory()
		this.getBigCategory()
		this.getCustomer()
		this.initFilters()
		this.getShopList()
	},
	methods: {
		clearSearch () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
			this.ordernumber = ''
			this.customerName = ''
			this.matchCode = ''
			this.childordertype = ''
			this.giftFlag = '全部'
			this.paymentnumber = ''
			this.customercategoryid = []
			this.shopids = []
			this.orderstatus = []
		},
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
			})
		},
		bcChange (value) {
			this.bigcategoryid = '' + value
			this.smallcategoryid = '0'
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		getSmalCategory () {
			let params = {
				pid: this.bigcategoryid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		// 是否开启小类
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
			})
		},
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		getCustomer () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		initFilters () {
			if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
				let Params = decodeURI(this.$route.query.throughParams)
				let throughParams = this.$fxUtils.JSONparse(Params)
				if (throughParams) {
					this.customerName = (throughParams.customerName && throughParams.customerName.value) || ''
					this.ordernumber = (throughParams.ordernumber && throughParams.ordernumber.value) || ''
					this.giftFlag = (throughParams.giftFlag && throughParams.giftFlag.value) || '全部'
					this.orderstatus = (throughParams.orderstatus && throughParams.orderstatus.value.split(',')) || []
					let startDate = throughParams.startDate.value.split(' ')
					let endDate = throughParams.endDate.value.split(' ')
					this.dateValue = [startDate[0] + ` ${startDate[1].substring(0, 5)}`, endDate[0] + ` ${endDate[1].substring(0, 5)}`]
				}
			} else {
				this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
			}
		},
		getFiltersDate () {
			return [
				{ name: 'startDate', field: 'createDate', value: `${this.dateValue[0]}:00`, 'op': 'ge', type: 'filtersParams' },
				{ name: 'endDate', field: 'createDate', value: `${this.dateValue[1]}:59`, 'op': 'le', type: 'filtersParams' }
			]
		},
		getFiltersParams () {
			let filtersParams = []
			let cParams = []
			if (this.dateValue === '' ||
				this.dateValue === null ||
				this.dateValue === undefined) {
				filtersParams = [
					{ field: 'createDate', data: ``, 'op': 'ge', name: '下单时间' },
					{ field: 'createDate', data: ``, 'op': 'le', name: '下单时间' }
				]
			} else {
				filtersParams = [
					{ field: 'createDate', data: `${this.dateValue[0]}:00`, 'op': 'ge', name: '下单时间' },
					{ field: 'createDate', data: `${this.dateValue[1]}:59`, 'op': 'le', name: '下单时间' }
				]
			}
			if (this.matchCode) {
				let matchCode = { 'field': 'matchCode', 'data': this.matchCode, 'op': 'cn' }
				cParams.push(matchCode)
			}
			if (this.paymentnumber) {
				let paymentnumber = { 'field': 'paymentnumber', 'data': this.paymentnumber, 'op': 'cn' }
				cParams.push(paymentnumber)
			}
			if (this.childordertype !== '') {
				let ordertypeObj = { 'field': 'ordertype', 'data': this.childordertype, 'op': 'eq' }
				filtersParams.push(ordertypeObj)
			}
			if (this.ordernumber) {
				let orderNoObj = { 'field': 'ordernumber', 'data': this.ordernumber, 'op': 'cn' }
				cParams.push(orderNoObj)
			}
			if (this.customerName) {
				let customerNameObj = { 'field': 'customerName', 'data': this.customerName, 'op': 'cn' }
				cParams.push(customerNameObj)
			}
			if (this.shopids.length > 0) {
				let data = this.shopids.join(',')
				let shopObj = { 'field': 'shopid', 'data': data, 'op': 'in' }
				filtersParams.push(shopObj)
			}
			if (this.customercategoryid.length !== 0) {
				let customercategoryid = { 'field': 'customercategoryid', 'data': this.customercategoryid.join(','), 'op': 'in' }
				filtersParams.push(customercategoryid)
			}
			if (this.orderstatus.length !== 0) {
				let orderstatus = { 'field': 'orderstatus', 'data': this.orderstatus.join(','), 'op': 'in' }
				filtersParams.push(orderstatus)
			}
			if (this.giftFlag !== '全部') {
				let giftFlag = { 'field': 'giftFlag', 'data': this.giftFlag, 'op': 'eq' }
				filtersParams.push(giftFlag)
			}
			return {
				filtersParams,
				cParams
			}
		},
		handleCollapse () {
			this.collapse = !this.collapse
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	display: flex
	.filters-box-row {
		flex: 1
		display:flex
		flex-wrap: wrap
		overflow: hidden
		&>div {
			margin-bottom: 10px
			&>span {
				display: inline-block;
				width: 120px;
				text-align: right
			}
		}
		.order-type-box {
			// margin-right:10px
			.order-type-select {
				width:150px
			}
		}
		.order-NO-box, .order-name-box{
			// margin-right: 10px;
			.order-input {
				width:150px
			}
		}
	}
	.collapse-box {
		width: 80px;
		margin-left: 10px
		flex-shrink: 0
	}
}
</style>
<style lang="stylus">
.filter-time-popper {
	.el-button--text {
		display: none
	}
}
</style>
